import { useIntl } from "react-intl"
import { Field } from "redux-form"
import { InputField, LinkInput } from "../../../inputs/connected-input-fields"
import { mustBeValidCustomLink, required, validatedIf } from "../../validators"
import React, { ReactNode } from "react"

interface Props {
  name: string
  children?: ReactNode
  disabled?: boolean
  urlDisabled?: boolean
}

export const LinkFields = ({ children, disabled, urlDisabled }: Props) => {
  const intl = useIntl()
  const urlEffectivelyDisabled = disabled || urlDisabled

  return (
    <div className="link-details">
      <div className="tw-absolute tw-top-1 tw-right-1 tw-z-[2] tw-flex tw-items-center tw-gap-2">
        {children}
      </div>

      <Field
        name="title"
        component={InputField}
        label={intl.formatMessage({ id: "input.addLink.titleField.label" })}
        placeholder={intl.formatMessage({
          id: "input.addLink.descriptionField.placeholder",
        })}
        disabled={disabled}
        validate={validatedIf(!disabled, required)}
        className="tw-mt-3"
      />

      <Field
        name="url"
        component={LinkInput}
        disabled={urlEffectivelyDisabled}
        validate={validatedIf(!urlEffectivelyDisabled, [required, mustBeValidCustomLink])}
      />
    </div>
  )
}
